import { zodResolver } from "@hookform/resolvers/zod";
import { Button, Grid } from "@mui/material";
import { t } from "i18next";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { COMPANY_ROLE_CHOICES } from "../../../helpers/constants";
import {
    useCompaniesShort,
    useConnectPersonToCompanyMutation,
} from "../../../services/customersService";
import BasicDialog from "../../base/BasicDialog";
import { ControlledSelect } from "../../form/ControlledSelect/ControlledSelect";

const addCompanyToCustomerFormSchema = z.object({
    companyId: z.string().nonempty(),
    companyName: z.string().optional(),
    companyNip: z.string().optional(),
    companyAddress: z.string().optional(),
    companyRole: z.string().nonempty(),
});

export function AddCompanyForPersonDialog(props) {
    const { mutate: connectPersonToCompany } = useConnectPersonToCompanyMutation();

    const { control, handleSubmit, setValue } = useForm({
        resolver: zodResolver(addCompanyToCustomerFormSchema),
        defaultValues: {
            companyId: "",
            companyName: "",
            companyNip: "",
            companyAddress: "",
            companyRole: "",
        },
    });

    const { data: companiesShort } = useCompaniesShort({
        select: (data) => data.results,
    });

    const onSubmit = (data) => {
        connectPersonToCompany({
            companyId: data.companyId,
            role: data.companyRole,
            personId: props.personId,
        });
        props.onClose();
    };

    return (
        // @ts-ignore
        <BasicDialog
            open={props.open}
            onClose={props.onClose}
            titleAlign={"center"}
            contentAlign={"center"}
            title={t("clients.companyPersonDialog.title")}
            maxWidth={"sm"}
            showDialogActions
            titleSx={{
                pb: 0,
            }}
        >
            <Grid container gap={2}>
                <Grid item xs={12}>
                    <ControlledSelect
                        control={control}
                        label={t("clients.companyPersonDialog.company")}
                        name="companyId"
                        data={
                            companiesShort?.map((company) => ({
                                value: company.id,
                                label: company.name,
                            })) || []
                        }
                    />
                </Grid>
                <Grid item xs={12}>
                    <ControlledSelect
                        control={control}
                        label={t("clients.companyPersonDialog.nip")}
                        name="companyId"
                        data={
                            companiesShort?.map((company) => ({
                                value: company.id,
                                label: company.company_nip,
                            })) || []
                        }
                    />
                </Grid>
                <Grid item xs={12}>
                    <ControlledSelect
                        control={control}
                        label={t("clients.companyPersonDialog.address")}
                        name="companyId"
                        data={
                            companiesShort?.map((company) => ({
                                value: company.id,
                                label: company.company_short_address,
                            })) || []
                        }
                    />
                </Grid>
                <Grid item xs={12}>
                    <ControlledSelect
                        control={control}
                        label={t("clients.companyPersonDialog.role")}
                        name="companyRole"
                        data={COMPANY_ROLE_CHOICES.map((role) => ({
                            label: t(`company.roles.${role}`),
                            value: role,
                        }))}
                    />
                </Grid>
                <Button
                    sx={{ mt: 4 }}
                    fullWidth
                    variant="contained"
                    onClick={handleSubmit(onSubmit)}
                >
                    {t("clients.companyPersonDialog.connect")}
                </Button>
            </Grid>
        </BasicDialog>
    );
}
